import API from "../../Api";
import { tinyURLRequest } from "./tinyURLModels";
import { encryptJson } from "../../utils/react-ec-utils";
export function getActualURLAPI(details: tinyURLRequest) {
  const data = encryptJson(details)
  return API({
    method: "POST",
    url: "/api/customers/delivery/getActualURL",
    data:{"data":data}
  });
}
